import { render, staticRenderFns } from "./businessTemplate.vue?vue&type=template&id=3fb51422&scoped=true&"
import script from "./businessTemplate.vue?vue&type=script&lang=ts&"
export * from "./businessTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb51422",
  null
  
)

export default component.exports